import { render } from "./WalletInstructions.vue?vue&type=template&id=88c2dca2&scoped=true"
import script from "./WalletInstructions.vue?vue&type=script&lang=js"
export * from "./WalletInstructions.vue?vue&type=script&lang=js"

import "./WalletInstructions.vue?vue&type=style&index=0&id=88c2dca2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c2dca2"]])

export default __exports__